export const employees = {
  en: {
    noContractHeading: "This employee has no contract",
    noContractExplain: "Employment — position, branch, salary, leave entitlement — is held on the contract, so without one this person cannot be included in a payroll run, accrues no leave, and no document can be issued for them.",
    noContractAskHr: "Ask HR to create one.",
    giveContract: "Create their contract",
    tabProfile: "Profile",
    tabContracts: "Contracts",
    tabAttendance: "Attendance",
    tabLeave: "Leave",
    tabPayroll: "Payroll",
    tabDocuments: "Documents",
    personalDetails: "Personal details",
    employeeNotFound: "That employee was not found.",
    filesTitle: "Attached files",
    filesHint: "Papers this system did not produce — a scanned iqama, a certificate, a signed contract. PDF, PNG or JPEG, up to 10 MB. Nothing here is read or interpreted by the system.",
    filesEmpty: "No files attached yet.",
    fileAdd: "Attach a file",
    fileName: "Name",
    fileNameRequired: "Give the file a name, so it can be recognised later.",
    fileChoose: "File",
    filePickOne: "Choose a file first.",
    fileTooLarge: "That file is larger than 10 MB.",
    fileUnsupportedType: "Only PDF, PNG and JPEG can be attached — those are the ones the browser can show you.",
    fileUnreadable: "That file could not be read. Please choose it again.",
    fileSize: "Size",
    fileUpload: "Attach",
    fileExpiresOn: "Expires on",
    fileExpiryHint: "Optional. Set it for anything that has to be renewed — an iqama, a licence — and the system will warn before the date passes.",
    fileExpired: "Expired",
    fileExpiresInDays: "{days} days left",
    fileExpiredDaysAgo: "expired {days} days ago",
    fileExpiringHeading: "Papers on this record are due for renewal",
    fileExpiredHeading: "Papers on this record have expired",
    filesExpiringTitle: "Papers expiring soon",
    filesExpiringEmpty: "Nothing expiring in the next 60 days.",
    firstNameAr: "First name (Arabic)",
    lastNameAr: "Last name (Arabic)",
    dateOfBirth: "Date of birth",
    gender: "Gender",
    male: "Male",
    female: "Female",
    department: "Department",
    role: "Access",
    title: "Employees",
    newEmployee: "New employee",
    employeeCode: "Employee number",
    fullName: "Name",
    employeeCodeIssued: "Issued automatically when you save.",
    employeeCodeIssuedAs: "Leave blank and {code} will be issued. Type a number to use your own.",
    employeeCodeOverridden: "This number will be used as typed. It must not already be in use.",
    deleteEmployee: "Delete employee",
    deleteEmployeeTitle: "Delete {name}?",
    deleteEmployeeBody: "This removes the person and everything listed below. It cannot be undone. Type their employee number to confirm.",
    deleteBlocked: "This person cannot be deleted:",
    deleteBlockedAdvice: "These records outlive the employee record — a wage record is retained by law, and an issued document exists in the world. To end their employment, terminate their contract instead.",
    deleteWhatPointsAtThem: "What points at this person:",
    deleteBlocking: "blocks deletion",
    deleteGoesWithThem: "removed with them",
    blocker_documents: "An issued document",
    blocker_payroll_items: "A payroll line",
    blocker_payroll_runs: "A payroll run",
    blocker_loans: "A salary advance",
    blocker_contracts: "A contract beyond draft",
    firstName: "First name",
    contractType: "Contract type",
    startDate: "Start date",
    endDate: "End date",
    lastName: "Last name",
    nationalId: "National ID / Iqama",
    nationality: "Nationality",
    hireDate: "Date of joining",
    jobTitle: "Job title",
    manager: "Reports to",
    contract: "Contract",
    noActiveContract: "No active contract",
    statusActive: "Active",
    statusOnLeave: "On leave",
    statusSuspended: "Suspended",
    statusTerminated: "Terminated",
    contractsTitle: "Contracts",
    basicSalary: "Basic salary",
    housingAllowance: "Housing allowance",
    transportAllowance: "Transport allowance",
    grossSalary: "Total monthly salary",
    gosi: "GOSI (employee share)",
    probation: "Probation",
    searchPlaceholder: "Search by name, number or ID",
    countLabel: "{count} employees",
  },
  ar: {
    noContractHeading: "لا يوجد عقد لهذا الموظف",
    noContractExplain: "بيانات التوظيف — المسمى والفرع والراتب ورصيد الإجازات — محفوظة في العقد، ومن دونه لا يمكن إدراج هذا الموظف في مسير الرواتب، ولا يتراكم له رصيد إجازات، ولا يمكن إصدار أي مستند باسمه.",
    noContractAskHr: "اطلب من الموارد البشرية إنشاء عقد.",
    giveContract: "إنشاء عقده",
    tabProfile: "الملف الشخصي",
    tabContracts: "العقود",
    tabAttendance: "الحضور",
    tabLeave: "الإجازات",
    tabPayroll: "الرواتب",
    tabDocuments: "المستندات",
    personalDetails: "البيانات الشخصية",
    employeeNotFound: "لم يتم العثور على هذا الموظف.",
    filesTitle: "الملفات المرفقة",
    filesHint: "أوراق لم يصدرها النظام — صورة الإقامة، شهادة، عقد موقّع. بصيغة PDF أو PNG أو JPEG، بحد أقصى 10 ميجابايت. النظام يحفظها فقط ولا يقرأ محتواها.",
    filesEmpty: "لا توجد ملفات مرفقة بعد.",
    fileAdd: "إرفاق ملف",
    fileName: "الاسم",
    fileNameRequired: "أدخل اسماً للملف حتى يمكن التعرف عليه لاحقاً.",
    fileChoose: "الملف",
    filePickOne: "اختر ملفاً أولاً.",
    fileTooLarge: "حجم الملف يتجاوز 10 ميجابايت.",
    fileUnsupportedType: "يمكن إرفاق ملفات PDF و PNG و JPEG فقط، لأنها الأنواع التي يمكن عرضها في المتصفح.",
    fileUnreadable: "تعذر قراءة هذا الملف. يرجى اختياره مرة أخرى.",
    fileSize: "الحجم",
    fileUpload: "إرفاق",
    fileExpiresOn: "تاريخ الانتهاء",
    fileExpiryHint: "اختياري. حدده لكل ما يحتاج إلى تجديد — الإقامة، الرخصة — لينبهك النظام قبل انتهائه.",
    fileExpired: "منتهي",
    fileExpiresInDays: "متبقٍ {days} يوم",
    fileExpiredDaysAgo: "انتهى قبل {days} يوم",
    fileExpiringHeading: "أوراق في هذا السجل تحتاج إلى تجديد",
    fileExpiredHeading: "أوراق في هذا السجل منتهية الصلاحية",
    filesExpiringTitle: "أوراق تقترب من الانتهاء",
    filesExpiringEmpty: "لا يوجد ما ينتهي خلال الستين يوماً القادمة.",
    firstNameAr: "الاسم الأول (بالعربية)",
    lastNameAr: "اسم العائلة (بالعربية)",
    dateOfBirth: "تاريخ الميلاد",
    gender: "الجنس",
    male: "ذكر",
    female: "أنثى",
    department: "القسم",
    role: "الصلاحية",
    title: "الموظفون",
    newEmployee: "موظف جديد",
    employeeCode: "الرقم الوظيفي",
    fullName: "الاسم",
    employeeCodeIssued: "يُصدر تلقائياً عند الحفظ.",
    employeeCodeIssuedAs: "اتركه فارغاً وسيُمنح الرقم {code}. أو اكتب رقماً لاستخدام رقمك الخاص.",
    employeeCodeOverridden: "سيُستخدم هذا الرقم كما كُتب، بشرط ألا يكون مستخدماً من قبل.",
    deleteEmployee: "حذف الموظف",
    deleteEmployeeTitle: "حذف {name}؟",
    deleteEmployeeBody: "سيُحذف الموظف وكل ما هو مذكور أدناه، ولا يمكن التراجع. اكتب رقمه الوظيفي للتأكيد.",
    deleteBlocked: "لا يمكن حذف هذا الموظف:",
    deleteBlockedAdvice: "هذه السجلات تبقى بعد سجل الموظف — سجل الأجور محفوظ نظاماً، والمستند الصادر موجود لدى صاحبه. لإنهاء العلاقة الوظيفية، أنهِ العقد بدلاً من الحذف.",
    deleteWhatPointsAtThem: "ما يرتبط بهذا الموظف:",
    deleteBlocking: "يمنع الحذف",
    deleteGoesWithThem: "يُحذف معه",
    blocker_documents: "مستند صادر",
    blocker_payroll_items: "بند في مسير الرواتب",
    blocker_payroll_runs: "مسير رواتب",
    blocker_loans: "سلفة",
    blocker_contracts: "عقد تجاوز مرحلة المسودة",
    firstName: "الاسم الأول",
    contractType: "نوع العقد",
    startDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
    lastName: "اسم العائلة",
    nationalId: "رقم الهوية / الإقامة",
    nationality: "الجنسية",
    hireDate: "تاريخ الالتحاق",
    jobTitle: "المسمى الوظيفي",
    manager: "المدير المباشر",
    contract: "العقد",
    noActiveContract: "لا يوجد عقد ساري",
    statusActive: "على رأس العمل",
    statusOnLeave: "في إجازة",
    statusSuspended: "موقوف",
    statusTerminated: "منتهية خدمته",
    contractsTitle: "العقود",
    basicSalary: "الراتب الأساسي",
    housingAllowance: "بدل السكن",
    transportAllowance: "بدل النقل",
    grossSalary: "إجمالي الراتب الشهري",
    gosi: "التأمينات (حصة الموظف)",
    probation: "فترة التجربة",
    searchPlaceholder: "ابحث بالاسم أو الرقم الوظيفي أو الهوية",
    countLabel: "{count} موظف",
  },
} as const;
